module.exports = __webpack_public_path__ + "png/royal_flush.png?413f834e4aa05af55287cbdca1813846";